import React from 'react';
import { bookData } from '../data/mock';
import { FileText, Quote } from 'lucide-react';

export const Preface = () => {
  return (
    <section id="prefazione" className="section-container bg-secondary-olive py-24">
      <div className="container mx-auto px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-brand-primary" />
              <h2 className="heading-1 text-brand-primary">Prefazione</h2>
            </div>
            <div className="w-24 h-1 bg-brand-primary mx-auto mb-8"></div>
          </div>

          <div className="bg-bg-page/70 backdrop-blur-sm p-10 md:p-12 rounded-lg border border-border-medium">
            <div className="relative mb-8">
              <Quote className="w-12 h-12 text-brand-primary opacity-20 absolute -top-2 -left-2" />
              <div className="relative z-10">
                {bookData.preface.text.split('\n\n').map((paragraph) => (
                  <p key={paragraph.slice(0, 40)} className="body-medium text-text-secondary leading-relaxed mb-6 last:mb-0 text-justify">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
            
            <div className="mt-10 pt-8 border-t-2 border-brand-primary">
              <div className="text-right">
                <p className="body-medium text-brand-primary font-bold mb-1">
                  {bookData.preface.author}
                </p>
                <p className="body-small text-text-secondary italic">
                  {bookData.preface.role}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
